var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._g(_vm._b({domProps:{"value":_vm.value}},'select',_vm.$attrs,false),_vm.inputListeners),_vm._l((_vm.options),function(option){return _c('option',{key:option[_vm.labelBy],domProps:{"value":String(option[_vm.labelBy])}},[_vm._v(" "+_vm._s(option[_vm.trackBy])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }